import { createSelector } from 'reselect'

export const getCurrentUserSettings = (state, props) => {
  return state.kanbo.currentUser.settings
}

export const getLandingPageSettings = (state, props) => {
  return state['view-home'].settings
}

export const makeCurrentUserSettingsSelector = () => createSelector(
  [getCurrentUserSettings, getLandingPageSettings],
  (currentUserSettings, landingPageSettings) => {
    return {
      ...currentUserSettings,
      lang: currentUserSettings.lang || landingPageSettings.lang
    }
  }
)

export const currentUserSettingsSelector = makeCurrentUserSettingsSelector()
